import { medRequestStatusValueToLabel } from '@/constants/statuses'
import { Chip } from '@mui/material'

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  'wc-item-created': { bg: '#ECEFF1', text: '#455A64' },
  'wc-item-duplicate-check': { bg: '#FFF8E1', text: '#F57F17' },
  'wc-item-system-id-check': { bg: '#E1F5FE', text: '#0277BD' },
  'wc-item-approved': { bg: '#E8F5E9', text: '#1B5E20' },
  'wc-item-rejected': { bg: '#FFEBEE', text: '#C62828' },
  'wc-item-refunded': { bg: '#FFCDD2', text: '#B71C1C' },
  'wc-item-system-scr-check': { bg: '#E0F7FA', text: '#00838F' },
  'wc-item-decision-assistant-check': { bg: '#E8EAF6', text: '#303F9F' },
  'wc-item-system-fan-check': { bg: '#E0F2F1', text: '#00695C' },
  'wc-item-clinical-review': { bg: '#F3E5F5', text: '#7B1FA2' },
  'wc-item-clinical-query': { bg: '#EDE7F6', text: '#4527A0' },
  'wc-item-clinical-fan': { bg: '#FCE4EC', text: '#AD1457' },
  'wc-item-clinical-video': { bg: '#E3F2FD', text: '#1565C0' },
  'wc-item-approved-future': { bg: '#C8E6C9', text: '#2E7D32' },
  'wc-item-awaiting-vendor-decision': { bg: '#FFF3E0', text: '#E65100' }
}

const DEFAULT_COLOR = { bg: '#F3F4F6', text: '#374151' }

export default function MedReqStatusBadge({ status }: { status: string }) {
  const label = medRequestStatusValueToLabel(status)
  const color = STATUS_COLORS[status] ?? DEFAULT_COLOR

  return (
    <Chip
      label={label}
      size='small'
      sx={{
        backgroundColor: color.bg,
        color: color.text,
        fontWeight: 600,
        fontSize: '12px',
        borderRadius: '6px'
      }}
    />
  )
}
